import { combineReducers } from "redux";

import { signatureConstants } from "../../actions/signature/index";

function documentsToSign(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;

  if (type === signatureConstants.GET_DOCUMENTS_TO_SIGN_SUCCESS) {
    if (defaultState && payload.isAppend) {
      const cloneDefaultState = [...defaultState.results._embedded.documentList];
      const newObject = cloneDefaultState.concat(payload.data._embedded.documentList);
      payload.data._embedded.documentList = newObject;
    }
    return {
      ...defaultState,
      results: payload.data
    };
  } 
  return defaultState;
  
}

function isGettingDocumentsToSign(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case signatureConstants.GET_DOCUMENTS_TO_SIGN_START:
    return true;
  case signatureConstants.GET_DOCUMENTS_TO_SIGN_SUCCESS:
  case signatureConstants.GET_DOCUMENTS_TO_SIGN_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isErrorGettingDocumentsToSign(state, { type, error }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case signatureConstants.GET_DOCUMENTS_TO_SIGN_ERROR:
    return error;
  case signatureConstants.GET_DOCUMENTS_TO_SIGN_START:
  case signatureConstants.GET_DOCUMENTS_TO_SIGN_SUCCESS:
    return false;
  default:
    return defaultState;
  }
}

function documentSign(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case signatureConstants.SIGN_SUCCESS:
    return {
      ...defaultState,
      payload
    };

  default:
    return defaultState;
  }
}

function isDocumentSign(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case signatureConstants.SIGN_START:
    return true;
  case signatureConstants.SIGN_SUCCESS:
  case signatureConstants.SIGN_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isErrorDocumentSign(state, { type, error }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case signatureConstants.SIGN_ERROR:
    return error;
  case signatureConstants.SIGN_START:
  case signatureConstants.SIGN_SUCCESS:
  default:
    return defaultState;
  }
}

function documentsSigned(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  if (type === signatureConstants.GET_DOCUMENTS_SIGNED_SUCCESS) {
    return {
      ...defaultState,
      results: payload
    };
  } 
  return defaultState;
  
}

function isGettingDocumentsSigned(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case signatureConstants.GET_DOCUMENTS_SIGNED_START:
    return true;
  case signatureConstants.GET_DOCUMENTS_SIGNED_SUCCESS:
  case signatureConstants.GET_DOCUMENTS_SIGNED_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isErrorGettingDocumentsSigned(state, { type, error }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case signatureConstants.GET_DOCUMENTS_SIGNED_ERROR:
    return error;
  case signatureConstants.GET_DOCUMENTS_SIGNED_START:
  case signatureConstants.GET_DOCUMENTS_SIGNED_SUCCESS:
    return false;
  default:
    return defaultState;
  }
}

export const signature = combineReducers({
  documentsToSign,
  isGettingDocumentsToSign,
  isErrorGettingDocumentsToSign,
  documentSign,
  isDocumentSign,
  isErrorDocumentSign,
  documentsSigned,
  isGettingDocumentsSigned,
  isErrorGettingDocumentsSigned
});

export default signature;
